import Device from './class/device';

Device.init();
const { isMac, isSafari, isLowPower } = Device;

isLowPower
  .then((result) => {
    if (isMac && isSafari && result) {
      document.body.classList.add('low-power-mode');
    }
  })
  .catch((err) => {
    console.warn('Low power detection failed:', err);
  });

export function detectSafari() {
    const ua = navigator.userAgent;
    return /^((?!chrome|android).)*safari/i.test(ua);
}

export function addBrowserClass() {
    if (detectSafari()) {
        document.body.classList.add('safari');
    } else {
        document.body.classList.add('not-safari');
    }
}